import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import DoubleCheckIcon from '@material-ui/icons/DoneAll';
import ShippingIcon from '@material-ui/icons/LocalShipping';

import BrandLogoImage from './../common/BrandLogoImage';
import {
  EuropeanStockBadge,
  EuropeanStockNotice,
  EU_STOCK_TONE,
} from './../common/EuropeanStockMark';
import { getTireAvailabilityDetails } from './../list/tireAvailabilityDetails';
import commons from './../common/commons';
import CartItemPriceRow from './CartItemPriceRow';
import CartSizeLines from './CartSizeLines';

const hebrewLables = {
  freeShipping: 'משלוח חינם',
  lastPurchase: 'רכישה אחרונה: {x}',
  setOfTires: 'סט צמיגים',
  outStock: 'לא במלאי',
  preSale: 'צפי הגעה: %s',
  inStock: 'במלאי מיידי',
  likeButtonTextToggleOff: 'לחץ לסמן שאתה אוהב את המוצר',
  learnMoreButtonText: 'מידע נוסף',
  addToCartButtonText: 'הזמנה',
  showMoreArrowText: 'פתח לעוד מידע',
  removeItemFromCart: 'הסר מהעגלה',
};

const styles = theme => ({
  card: {
    maxWidth: 400,
    marginTop: 40,
    marginLeft: 'auto',
    marginRight: 'auto',
    position: 'relative',
  },
  content: {
    padding: 5,
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  media: {
    height: 194,
    backgroundPosition: 'top',
  },
  brandLogo: {
    position: 'absolute',
    maxHeight: 26,
    top: 3,
    right: 3,
  },
  button: {
    margin: theme.spacing(),
  },
  cardHeader: {
    flip: false,
    direction: 'ltr',
  },
  cardMediaContainer: {
    position: 'relative',
  },
  '@media (min-width: 1024px)': {
    card: {
      display: 'none',
    },
    desktopBox: {
      margin: '8px 0',
      padding: 8,
      background: '#fefefe',
      display: 'block',
    },
    brandLogo: {
      position: 'initial',
      top: 'initial',
      right: 'initial',
      height: 18,
    },
    brandContainer: {
      display: 'flex',
      flexGrow: 1,
      justifyContent: 'center',
    },
    desktopDataContainer: {
      position: 'relative',
    },
    desktopControlContainer: {
      display: 'inline-block',
      position: 'absolute',
      width: 'auto',
      bottom: 0,
      right: 0,
    },
    desktopDataInnerContainer: {
      // direction: 'ltr',
      display: 'block',
      paddingLeft: 16,
    },
    primaryPhotoContainer: {
      display: 'flex',
      flexGrow: 1,
      justifyContent: 'center',
    },
    title: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontSize: 24,
      margin: 8,
    },
    preOrder: {
      background: '#0d9b4b',
      color: '#fefefe',
    },
    outOfStock: {
      background: '#ba2218',
      color: '#fefefe',
    },
    subheading: {
      margin: '4px 8px',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontSize: 15,
      fontWeight: 400,
      color: '#9a9a9a',
    },
    featuresPool: {
      direction: 'ltr',
      margin: '4px 8px',
    },
    featureItem: {
      margin: 4,
    },
    desktopPrimaryPhoto: {
      height: 194,
    },
  },
  euCard: {
    borderTop: `4px solid ${EU_STOCK_TONE.accent}`,
  },
  euBlock: {
    margin: '4px 8px 8px',
  },
});

class CartItemDesktop extends React.Component {
  removeItemFromCart = () => {
    this.props.onRemoveFromCart(this.props.data.ean);
  };

  render() {
    const { classes, data, cardCount, currentShipment, availabilityContext } = this.props;

    const {
      displayName,
      brand,
      ean,
      set,
      visibility = 'none',
      free_shipping,
      cdn = false,
      displaySize,
      source,
    } = data;

    const { url: primaryPhoto } = commons.getProductPrimaryImage(
      cdn,
      ean,
      source === 'georgia'
    );

    const extraStyles = {};
    if (cardCount === 0) {
      extraStyles.marginTop = '10px';
    }

    let stockLabel;
    const displayGreenVisibilityChip = (visibility === 'instock' || visibility === 'preorder') ? true : false;
    const displayOutOfStock = visibility === 'outofstock';

    switch (visibility) {
      case 'instock':
        stockLabel = hebrewLables.inStock;
        break;
      case 'preorder':
        stockLabel = hebrewLables.preSale.replace('%s', currentShipment);
        break;
    }

    const availability = getTireAvailabilityDetails(data, availabilityContext);
    const isEu = availability.kind === 'eu';

    return (
      <React.Fragment>
        <Paper className={classNames(classes.desktopBox, isEu && classes.euCard)}>
          <Grid container spacing={0} className={classes.desktopDataContainer}>
            <Grid item xs={3}>
              <Grid container spacing={0}>
                <Grid item className={classes.primaryPhotoContainer}>
                  <img
                    className={classes.desktopPrimaryPhoto}
                    alt={`${brand} ${displayName} ${displaySize}`}
                    src={primaryPhoto}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={0}>
                <Grid item className={classes.brandContainer}>
                  <BrandLogoImage
                    brand={brand}
                    alt={brand}
                    className={classes.brandLogo}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={9}>
              <CartItemPriceRow
                data={data}
                quantity={this.props.quantity}
                onChangeQuantity={this.props.onChangeQuantity}
              />
              <Grid
                container
                spacing={0}
                className={classes.desktopDataInnerContainer}
              >
                <h3 className={classes.title}>{displayName}</h3>

                <h4 className={classes.subheading}>{brand}</h4>

                <CartSizeLines product={data} />

                <Grid container spacing={0} className={classes.featuresPool}>
                  {displayOutOfStock && <Chip
                    className={classNames(
                      classes.featureItem,
                      classes.outOfStock
                    )}
                    label={hebrewLables.outStock}
                  />}

                  {displayGreenVisibilityChip && <Chip
                    className={classNames(
                      classes.featureItem,
                      classes.preOrder
                    )}
                    label={stockLabel}
                  />}

                  {set && (
                    <Chip
                      className={classNames(classes.featureItem)}
                      avatar={
                        <Avatar>
                          <DoubleCheckIcon />
                        </Avatar>
                      }
                      label={hebrewLables.setOfTires}
                    />
                  )}

                  {free_shipping && (
                    <Chip
                      className={classNames(
                        classes.featureItem,
                        classes.freeShippingChip
                      )}
                      avatar={
                        <Avatar>
                          <ShippingIcon />
                        </Avatar>
                      }
                      label={hebrewLables.freeShipping}
                    />
                  )}
                </Grid>
              </Grid>
              <Grid
                container
                spacing={0}
                className={classes.desktopControlContainer}
              >
                <Button variant="contained" onClick={this.removeItemFromCart}>
                  {hebrewLables.removeItemFromCart}
                </Button>
              </Grid>
            </Grid>
          </Grid>
          {isEu ? (
            <div className={classes.euBlock} dir="rtl">
              <EuropeanStockBadge label={availability.label} />
              <EuropeanStockNotice details={availability} />
            </div>
          ) : null}
        </Paper>
      </React.Fragment>
    );
  }
}

CartItemDesktop.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  currentShipment: PropTypes.string,
  availabilityContext: PropTypes.object,
  quantity: PropTypes.number.isRequired,
  cardCount: PropTypes.number.isRequired,
  onRemoveFromCart: PropTypes.func.isRequired,
  onChangeQuantity: PropTypes.func.isRequired,
};

export default withStyles(styles)(CartItemDesktop);
